/**
 * Modal surface scope — marks a React subtree as living inside a
 * modal-tier surface (z ≥ 31500, see interactive-layer.tsx).
 *
 * Portalled menu content (dropdown-menu.tsx) reads this to stamp
 * `data-modal-menu` on itself so the menu z-source in index.css can
 * promote it above its host modal. React context flows through
 * createPortal, so consumers work even though the menu DOM lands on
 * document.body.
 */
import { createContext, useContext, type ReactNode } from "react";

const ModalSurfaceContext = createContext(false);

/** True when rendered inside a modal-tier surface. */
function useInsideModalSurface(): boolean {
  return useContext(ModalSurfaceContext);
}

/** Wrap a modal shell's content so nested menus stack above the modal. */
function ModalSurfaceScope({ children }: { children: ReactNode }) {
  return (
    <ModalSurfaceContext.Provider value={true}>
      {children}
    </ModalSurfaceContext.Provider>
  );
}

/* eslint-disable react-refresh/only-export-components */
export { ModalSurfaceScope, useInsideModalSurface };
/* eslint-enable react-refresh/only-export-components */
